import React from 'react';
import { RouteConfig } from 'react-router-config';

import { PageRouteType, routePostProc } from '@/util/route';

const ProductAudit = React.lazy(
  () => import('@/page/app/operationMgt/productAudit')
);

const OPERATION_MGT_ROUTE: RouteConfig[] = [
  {
    path: '/productAudit',
    component: ProductAudit,
  },
];

export { OPERATION_MGT_ROUTE };
export default routePostProc(PageRouteType.OPERATION_MGT, OPERATION_MGT_ROUTE);
